module.exports = __webpack_public_path__ + "img/entry_exit.fed81257.svg";